import {
  REQUEST_TENANTS,
  RECEIVE_TENANTS,
  ADD_TENANT,
  UPDATE_TENANT,
  DELETE_TENANT,
} from '../actions';

const initialState = {
  isFetching: false,
  tenants: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUEST_TENANTS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_TENANTS:
      return {
        ...state,
        isFetching: false,
        tenants: action.tenants,
      };
    case ADD_TENANT:
      return {
        ...state,
        tenants: [...state.tenants, action.tenant],
      };
    case UPDATE_TENANT:
      return {
        ...state,
        tenants: state.tenants.map((tenant) => {
          if (tenant.id === action.tenant.id) return action.tenant;
          return tenant;
        }),
      };
    case DELETE_TENANT:
      return {
        ...state,
        tenants: state.tenants.filter(tenant => tenant.id !== action.id),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tenantReducer.js